export default {
  'menu.welcome': 'Selamat Datang',
  'menu.more-blocks': 'Blocks Lainnya',
  'menu.home': 'Halaman Awal',
  'menu.admin': 'Admin',
  'menu.admin.sub-page': 'Sub-Halaman',
  'menu.login': 'Masuk',
  'menu.register': 'Pendaftaran',
  'menu.register-result': 'Hasil Pendaftaran',
  'menu.dashboard': 'Dasbor',
  'menu.dashboard.analysis': 'Analisis',
  'menu.dashboard.monitor': 'Monitor',
  'menu.dashboard.workplace': 'Workplace',
  'menu.exception.403': '403',
  'menu.exception.404': '404',
  'menu.exception.500': '500',
  'menu.form': 'Form',
  'menu.form.basic-form': 'Form Dasar',
  'menu.form.step-form': 'Form Bertahap',
  'menu.form.step-form.info': 'Form Bertahap(menulis informasi yang dibagikan)',
  'menu.form.step-form.confirm':
    'Form Bertahap(konfirmasi informasi yang dibagikan)',
  'menu.form.step-form.result': 'Form Bertahap(selesai)',
  'menu.form.advanced-form': 'Form Lanjutan',
  'menu.list': 'Daftar',
  'menu.list.table-list': 'Tabel Pencarian',
  'menu.list.basic-list': 'Daftar Dasar',
  'menu.list.card-list': 'Daftar Kartu',
  'menu.list.search-list': 'Daftar Pencarian',
  'menu.list.search-list.articles': 'Daftar Pencarian(artikel)',
  'menu.list.search-list.projects': 'Daftar Pencarian(projek)',
  'menu.list.search-list.applications': 'Daftar Pencarian(aplikasi)',
  'menu.profile': 'Profil',
  'menu.profile.basic': 'Profil Dasar',
  'menu.profile.advanced': 'Profile Lanjutan',
  'menu.result': 'Hasil',
  'menu.result.success': 'Sukses',
  'menu.result.fail': 'Gagal',
  'menu.exception': 'Pengecualian',
  'menu.exception.not-permission': '403',
  'menu.exception.not-find': '404',
  'menu.exception.server-error': '500',
  'menu.exception.trigger': 'Jalankan',
  'menu.account': 'Akun',
  'menu.account.center': 'Detail Akun',
  'menu.account.settings': 'Pengaturan Akun',
  'menu.account.trigger': 'Mengaktivasi Error',
  'menu.account.logout': 'Keluar',
  'menu.editor': 'Penyusun Grafis',
  'menu.editor.flow': 'Penyusun Alur',
  'menu.editor.mind': 'Penyusun Mind',
  'menu.editor.koni': 'Penyusun Koni',
  
  // Activity Management
  'menu.activity': 'Manajemen Aktivitas',
  'menu.activity-list': 'Daftar Aktivitas',
  'menu.activity-create': 'Buat Aktivitas',
  'menu.activity-edit': 'Edit Aktivitas',
  'menu.activity-verification': 'Manajemen Verifikasi',
  
  // User Management
  'menu.user-management': 'Manajemen Pengguna',
  'menu.user-list': 'Daftar Pengguna',
  'menu.user-detail': 'Detail Pengguna',
  'menu.operator-management': 'Manajemen Operator',
  
  // Order Management
  'menu.order': 'Manajemen Pesanan',
  'menu.order-list': 'Daftar Pesanan',
  'menu.order-detail': 'Detail Pesanan',
  'menu.refund-management': 'Manajemen Pengembalian',
  
  // Mall Management
  'menu.mall': 'Manajemen Mall',
  'menu.product-management': 'Manajemen Produk',
  'menu.product-create': 'Tambah Produk',
  'menu.product-edit': 'Edit Produk',
  'menu.inventory-management': 'Manajemen Inventori',
  'menu.logistics-management': 'Manajemen Logistik',
  
  // Statistics
  'menu.statistics': 'Statistik',
  'menu.statistics-overview': 'Ringkasan Statistik',
  'menu.activity-statistics': 'Statistik Aktivitas',
  'menu.sales-statistics': 'Statistik Penjualan',
  
  // System Management
  'menu.system': 'Manajemen Sistem',
  'menu.system-config': 'Konfigurasi Sistem',
  'menu.system-logs': 'Log Operasi',
};
